"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AccountUser_1 = __importDefault(require("./AccountUser"));

var ArrowDown_1 = __importDefault(require("./ArrowDown"));

var ArrowLeft_1 = __importDefault(require("./ArrowLeft"));

var ArrowRight_1 = __importDefault(require("./ArrowRight"));

var ArrowUp_1 = __importDefault(require("./ArrowUp"));

var Calendar_1 = __importDefault(require("./Calendar"));

var CaretDown_1 = __importDefault(require("./CaretDown"));

var CaretLeft_1 = __importDefault(require("./CaretLeft"));

var CaretRight_1 = __importDefault(require("./CaretRight"));

var CaretUp_1 = __importDefault(require("./CaretUp"));

var Check_1 = __importDefault(require("./Check"));

var CheckinManual_1 = __importDefault(require("./CheckinManual"));

var CheckinScan_1 = __importDefault(require("./CheckinScan"));

var CreditCard_1 = __importDefault(require("./CreditCard"));

var CreditCardAmex_1 = __importDefault(require("./CreditCardAmex"));

var CreditCardVisa_1 = __importDefault(require("./CreditCardVisa"));

var CreditCardJBC_1 = __importDefault(require("./CreditCardJBC"));

var CreditCardDinnersClub_1 = __importDefault(require("./CreditCardDinnersClub"));

var CreditCardMastercard_1 = __importDefault(require("./CreditCardMastercard"));

var CreditCardDiscover_1 = __importDefault(require("./CreditCardDiscover"));

var Cross_1 = __importDefault(require("./Cross"));

var Google_1 = __importDefault(require("./Google"));

var Facebook_1 = __importDefault(require("./Facebook"));

var LoaderCircle_1 = __importDefault(require("./LoaderCircle"));

var LoaderDots_1 = __importDefault(require("./LoaderDots"));

var Minus_1 = __importDefault(require("./Minus"));

var Paypal_1 = __importDefault(require("./Paypal"));

var Plus_1 = __importDefault(require("./Plus"));

var Prototype_1 = __importDefault(require("./Prototype"));

var RezdyMark_1 = __importDefault(require("./RezdyMark"));

var RoundAlert_1 = __importDefault(require("./RoundAlert"));

var RoundCheck_1 = __importDefault(require("./RoundCheck"));

var RoundCross_1 = __importDefault(require("./RoundCross"));

var RoundDot_1 = __importDefault(require("./RoundDot"));

var RoundInfo_1 = __importDefault(require("./RoundInfo"));

var RoundOutline_1 = __importDefault(require("./RoundOutline"));

var RoundPlus_1 = __importDefault(require("./RoundPlus"));

var Slider_1 = __importDefault(require("./Slider"));

var Square_1 = __importDefault(require("./Square"));

var StarOutline_1 = __importDefault(require("./StarOutline"));

var StarFilled_1 = __importDefault(require("./StarFilled"));

var Eye_1 = __importDefault(require("./Eye"));

var EyeCrossed_1 = __importDefault(require("./EyeCrossed"));

var Stripe_1 = __importDefault(require("./Stripe"));

var Search_1 = __importDefault(require("./Search"));

exports.default = {
  'account-user': AccountUser_1.default,
  'arrow-down': ArrowDown_1.default,
  'arrow-left': ArrowLeft_1.default,
  'arrow-right': ArrowRight_1.default,
  'arrow-up': ArrowUp_1.default,
  calendar: Calendar_1.default,
  'caret-down': CaretDown_1.default,
  'caret-left': CaretLeft_1.default,
  'caret-right': CaretRight_1.default,
  'caret-up': CaretUp_1.default,
  check: Check_1.default,
  'checkin-manual': CheckinManual_1.default,
  'checkin-scan': CheckinScan_1.default,
  cross: Cross_1.default,
  'credit-card': CreditCard_1.default,
  'credit-card-visa': CreditCardVisa_1.default,
  'credit-card-mastercard': CreditCardMastercard_1.default,
  'credit-card-american-express': CreditCardAmex_1.default,
  'credit-card-diners-club': CreditCardDinnersClub_1.default,
  'credit-card-discover': CreditCardDiscover_1.default,
  'credit-card-jcb': CreditCardJBC_1.default,
  'credit-card-union-pay': CreditCard_1.default,
  'credit-card-maestro': CreditCardMastercard_1.default,
  'credit-card-mir': CreditCard_1.default,
  'credit-card-elo': CreditCard_1.default,
  'credit-card-hiper': CreditCard_1.default,
  'credit-card-hipercard': CreditCard_1.default,
  facebook: Facebook_1.default,
  google: Google_1.default,
  'loader-circle': LoaderCircle_1.default,
  'loader-dots': LoaderDots_1.default,
  minus: Minus_1.default,
  plus: Plus_1.default,
  prototype: Prototype_1.default,
  'rezdy-mark': RezdyMark_1.default,
  'round-alert': RoundAlert_1.default,
  'round-check': RoundCheck_1.default,
  'round-cross': RoundCross_1.default,
  'round-dot': RoundDot_1.default,
  'round-info': RoundInfo_1.default,
  'round-outline': RoundOutline_1.default,
  'round-plus': RoundPlus_1.default,
  search: Search_1.default,
  slider: Slider_1.default,
  square: Square_1.default,
  'star-outline': StarOutline_1.default,
  'star-filled': StarFilled_1.default,
  eye: Eye_1.default,
  'eye-crossed': EyeCrossed_1.default,
  paypal: Paypal_1.default,
  stripe: Stripe_1.default
};